/// <amd-module name="Release/Sharedcontributions/ReleaseMenuService" />
import * as React from "react";
import { Build } from "Build/Client/Contracts/Build";
import { IVssLayoutManager } from "VSS/Platform/Layout";
import { ILegacyComponentProperties, LegacyComponent } from "VSS/Legacy/Legacy";
import { ReactRootComponent } from "VSS/Platform/Layout";
import { IPivotBarAction } from "VSSUI/Components/PivotBar/PivotBarAction.Props";
import { IVssContributablePivotBarActionService } from "VSS/Features/Frame/IVssContributablePivotBarActionService";
import { IVssContributableMenuService } from "VSS/Features/Frame/IVssContributableMenuService";
import { Services, VssService, IVssService } from "VSS/Platform/Context";
import { IVssPerformanceService } from 'VSS/Platform/Performance';
import * as ReactDOM from 'react-dom';

export interface IReleaseMenuService extends IVssService {
    createRelease(build: Build): void;
}

class ReleaseMenuService extends VssService implements IReleaseMenuService, IVssContributablePivotBarActionService, IVssContributableMenuService {

    constructor() {
        super();
        setTimeout(() => {
            this._prefetchCreateReleasePanel();
        }, 500);
    }

    public loadItems(itemsUpdated: (items: IPivotBarAction[]) => void, buildData?: any): void {

    }

    //Prefetching Files to improve CreateReleasePanel performance.
    private _prefetchCreateReleasePanel = (): void => {
        const dummyContainer = document.createElement("div");
        let component = React.createElement(ReactRootComponent,
            {
                pageContext: this.pageContext
            },
            React.createElement(LegacyComponent, {
                modules: ["ReleasePipeline/Scripts/TFS.ReleaseManagement.BuildIntegration", "PipelineWorkflow/Scripts/SharedComponents/CreateRelease/CreateReleaseExtension", "PipelineWorkflow/Scripts/Shared/LegacyLWP/PrefetchPipelineWorkFlow"],
                wrappedType: "prefetch-create-release-panel",
                dependentContributionIds: ["ms.vss-releaseManagement-web.release-service-data-external"],
                dependencies: ["ms.vss-web.legacy-vss-ui-content",
                    "ms.vss-work-web.common-content"]
            } as ILegacyComponentProperties));
        ReactDOM.render(component, dummyContainer);
    }

    public createRelease(build: Build): void {
        const performanceService = this.pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
        const PerfConstants = { FeatureArea: "CD", CreateReleaseDialogScenario: "VSO.CD.OpenCreateReleaseDialog" };
        performanceService.startScenario(PerfConstants.CreateReleaseDialogScenario, true);
        const layoutManager = this.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
        layoutManager.renderCallout(() => {
            return React.createElement(LegacyComponent, {
                modules: ["ReleasePipeline/Scripts/TFS.ReleaseManagement.BuildIntegration"],
                wrappedType: "createReleaseDialog",
                dependentContributionIds: ["ms.vss-releaseManagement-web.release-service-data-external"],
                buildDetails: build,
                endPerfScenario: () => performanceService.endScenario(PerfConstants.FeatureArea, PerfConstants.CreateReleaseDialogScenario, true),
                vssPageContext: this.pageContext
            }, null);
        });
    }
}

Services.add("release-menu-service", { serviceFactory: ReleaseMenuService });
